import {Adhesive} from "@app/strain/config/adhesives/models/adhesive.model";
import {User} from "@app/shared/models";
import * as moment from 'moment';

export class StrainMeasurementGageMountingModel {
    public adhesive: Adhesive;
    public mountedBy: User;
    public evaluatedBy: string;
    public mountingDate: number;
    public evaluationDate: number;

    constructor(entry: any = {}) {
        this.adhesive = entry.adhesive ? new Adhesive(entry.adhesive) : null;
        this.mountedBy = entry.mountedBy ? new User(entry.mountedBy) : null;
        this.evaluatedBy = entry.evaluatedBy ? entry.evaluatedBy : "";
        this.mountingDate = entry.mountingDate ? moment(entry.mountingDate, "DD-MM-YYYY").valueOf() : 0;
        this.evaluationDate = entry.evaluationDate ? moment(entry.evaluationDate, "DD-MM-YYYY").valueOf() : 0;
    }
}
